import React from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../i18n';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const headerNavTextClass = 'text-white hover:text-gray-200 transition-colors font-bold text-sm lg:text-xs';

  const languages = [
    { code: 'ru', name: 'RU' },
    { code: 'en', name: 'EN' },
    { code: 'es', name: 'ES' },
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
  };

  return (
    <div className="relative group">
      <button className={`flex items-center px-1 py-2 bg-transparent hover:bg-transparent rounded-none uppercase ${headerNavTextClass}`}>
        <span>{currentLanguage.name}</span>
      </button>

      <div className="absolute top-full right-0 mt-2 w-20 bg-[#EC8C8E] rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {languages.map((language) => (
          <button
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            className={`w-full flex items-center justify-center px-3 lg:px-2 py-2 text-sm lg:text-xs font-bold text-white uppercase hover:bg-white/25 transition-colors first:rounded-t-lg last:rounded-b-lg ${
              i18n.language === language.code ? 'bg-white/25' : ''
            }`}
          >
            <span>{language.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
